// ── Einheiten ────────────────────────────────────────────────
// Alle Windwerte in der DB und in dieser App: m/s
// Temperatur: °C, Druck: hPa
// ────────────────────────────────────────────────────────────

import { houseFromX, floorFromY } from "./building-layout";

export const degToCompass = (deg) => {
  if (deg === null || deg === undefined) return "–";
  const dirs = ["N","NNO","NO","ONO","O","OSO","SO","SSO","S","SSW","SW","WSW","W","WNW","NW","NNW"];
  return dirs[Math.round(deg / 22.5) % 16];
};

// Beaufort-Skala in m/s
export const beaufort = (ms) => {
  if (ms === null || ms === undefined) return null;
  const scale = [0.3, 1.6, 3.4, 5.5, 8.0, 10.8, 13.9, 17.2, 20.8, 24.5, 28.5, 32.7];
  return scale.findIndex((v) => ms < v);
};

export const beaufortLabel = (b) => {
  const labels = ["Windstille","Leiser Zug","Leichte Brise","Schwache Brise",
    "Mässige Brise","Frische Brise","Starker Wind","Steifer Wind",
    "Stürmischer Wind","Sturm","Schwerer Sturm","Orkanartiger Sturm","Orkan"];
  return labels[b] ?? "–";
};

// Farbskala in m/s (20/40/60 km/h ≈ 5.6/11.1/16.7 m/s)
export const windColor = (ms) => {
  if (ms === null || ms === undefined) return "#94a3b8";
  if (ms < 5.6)  return "#22c55e";   // < 20 km/h – Ruhig
  if (ms < 11.1) return "#eab308";   // 20–40 km/h – Mässig
  if (ms < 16.7) return "#f97316";   // 40–60 km/h – Stark
  return "#ef4444";                   // > 60 km/h – Sturm
};

export const minutesAgoLabel = (min) => {
  if (min === null || min === undefined) return "–";
  if (min < 1) return "gerade eben";
  if (min < 60) return `vor ${min} Min.`;
  return `vor ${Math.round(min / 60)} Std.`;
};

/**
 * Liefert die Lage-Beschreibung eines Sensors als String, z.B. "5. OG • Nr. 52".
 * Nutzt zentrale Konstanten aus building-layout.js, damit Card-Text und
 * Gebäudeplan-Position immer übereinstimmen.
 */
export function sensorLage(s) {
  const x = s.position_x;
  const y = s.position_y;
  if (x === null || x === undefined) return null;

  const gebaeude = houseFromX(x);
  const etage = floorFromY(y);

  if (!gebaeude) return null;
  return etage ? `${etage} • ${gebaeude}` : gebaeude;
}
